<template>
  <footer class="footer">
    <div class="social-links">
      <a href="https://www.youtube.com/@krilinschmid" target="_blank"><i class="fab fa-youtube"></i></a>
      <a href="https://www.instagram.com/krilin.schmid/" target="_blank"><i class="fab fa-instagram"></i></a>
      <a href="https://x.com/KrilinSchmid" target="_blank"><i class="fab fa-twitter"></i></a>
      <a href="https://www.linkedin.com/in/krilin-schmid-831789221/" target="_blank"><i class="fab fa-linkedin"></i></a>
    </div>
    <p>&copy; 2025 Krilin Schmid. Alle Rechte vorbehalten.</p>
  </footer>
</template>

<style scoped>
.footer {
  background-color: #1c1c1c;
  padding: 2rem;
  text-align: center;
  margin-top: auto;
}

.social-links {
  margin-bottom: 1rem;
}

.social-links a {
  display: inline-block;
  color: var(--text-secondary);
  font-size: 2rem; 
  margin: 0 1rem;
  transition: color 0.3s ease;
  padding: 10px;
}

.social-links a:hover {
  color: var(--accent);
}

.footer p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}
</style>